import http from "@seims/shared/src/services/HttpService";

var endpoint = `/lookup/partnership/`;
const commonLookup = `/lookup/common/`;

const getTitles = async () => {
  const response = await http.get(`${commonLookup}titles`);
  return response;
};

const getPartnerTypes = async () => {
  const response = await http.get(`${endpoint}types`);
  return response;
};

const getOrganisationTypes = async () => {
  const response = await http.get(`${endpoint}organisationTypes`);
  return response;
};

const getLocalityTypes = async () => {
  const response = await http.get(`${endpoint}locality`);
  return response;
};

const getContributions = async (module) => {
  const response = await http.get(`${endpoint}contributions?contributionType=${module}`);
  return response;
};

const getPartnerDateTypes = async () => {
  const response = await http.get(`${endpoint}partnerDateTypes`);
  return response;
};

const getDocumentClassifications = async () => {
  const response = await http.get(`${endpoint}documentClassifications`);
  return response;
};

export default {
  getTitles,
  getPartnerTypes,
  getOrganisationTypes,
  getLocalityTypes,
  getContributions,
  getPartnerDateTypes,
  getDocumentClassifications,
};
